module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_html.js
// module id = 955
// module chunks = 48 49 50